import { useMutationState } from '@tanstack/react-query';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import { useMemo } from 'react';
import { useGetPromotionDetail } from '@/features/booking/api/promotion/use-get-promo';
import { assetPrefix } from '@/lib/constants';

const usePromoCode = () => {
  const [paramPromo] = useQueryState(
    'promo_code',
    parseAsArrayOf(parseAsString).withDefault([])
  );

  return {
    paramPromo,
    initialCode: paramPromo ?? '',
  };
};

const useMutationStatus = () => {
  const mutationStatusNationwide = useMutationState({
    filters: { mutationKey: ['estimateIntercityOrderFn'] },
    select: (mutation) => mutation.state.error,
  });

  const mutationStatusOther = useMutationState({
    filters: { mutationKey: ['estimateNewOrderFn'] },
    select: (mutation) => mutation.state.error,
  });

  const mutationLoadingStatus = useMutationState({
    filters: { status: 'pending' },
    select: (mutation) => mutation.state.status,
  });

  const loading = useMemo(
    () => mutationLoadingStatus?.length > 0,
    [mutationLoadingStatus]
  );

  return { mutationStatusNationwide, mutationStatusOther, loading };
};
const usePromoDetail = (promo_id: string) => {
  const {
    data: promo,
    isFetching,
    isError,
  } = useGetPromotionDetail(encodeURIComponent(promo_id));
  const imgUrl = useMemo(
    () =>
      promo?.image_url && promo?.image_url !== ''
        ? promo.image_url
        : `${assetPrefix}/static/images/default-promo-detail.webp`,
    [promo]
  );

  return { promo, isFetching, isError, imgUrl };
};
export { usePromoCode, useMutationStatus, usePromoDetail };
